import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {selectCurrentUser} from "../../../../features/authentication/authenticationSelectors";
import {useNavigate} from "react-router-dom";
import PermissionType from "../../../../data/enums/PermissionType";
import GridTabSection, {GridTabSectionType} from "../../../ui/components/Grid/GridTab/GridTabSection/GridTabSection";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import GridTabItem from "../../../ui/components/Grid/GridTab/GridTabItem/GridTabItem";
import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import GridTab from "../../../ui/components/Grid/GridTab/GridTab";
import Loader from "../../../ui/components/Loader/Loader";
import {Query} from "@syncfusion/ej2-data";
import {ColumnDirective, ColumnsDirective, Filter, Inject, Page as Pager, Sort} from "@syncfusion/ej2-react-grids";
import GridComponent from "../../../ui/components/Grid/GridComponent";
import ServiceWorkCategoryFilter from "./filters/ServiceWorkCategoryFilter";

const ServiceWork = () => {
    const {t} = useTranslation();
    const user = useSelector(selectCurrentUser);
    const navigate = useNavigate();

    const [tab, setTab] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [filterTrigger, setFilterTrigger] = useState(null);
    const [query, setQuery] = useState(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        setTab(urlParams.get('tab') ? urlParams.get('tab') : '0');
    }, []);

    useEffect(() => {
        setQuery((prev) => {
            if (!tab) {
                return null;
            }

            const q = new Query();

            if (prev && prev.params && prev.params.length > 0) {
                const params = prev.params.filter(item => item.key !== 'name' && item.key !== 'tab');
                for (const item of params) {
                    q.addParams(item.key, item.value);
                }
            }

            q.addParams('tab', tab.toString());

            return q;
        });
    }, [tab]);

    const onTabItemClick = ({id, queryParameterName, queryKey}) => {
        if (queryParameterName && queryKey) {
            setTab(queryKey);
        } else if (id === 'refresh-btn') {
            setRefreshTrigger(prev => prev + 1);
        }
    };

    const onRowDoubleClick = ev => {
        if (ev && ev.rowData) {
            navigate(`/property/services/service/${ev.rowData.id}`);
        }
    };

    if (user.permission.services === PermissionType.NotAvailable) {
        return null;
    }

    return (
        <div className='list-container'>
            <GridTab onClick={onTabItemClick}>
                <GridTabSection type={GridTabSectionType.Tab}
                                showRightSeparator={true}
                                queryParameterName='tab'>
                    <GridTabItem id='not-commercial-tab'
                                 text={t("serviceWork.grid.not-commercial-tab")}
                                 queryKey='0'
                                 isDefaultActive={true}>
                    </GridTabItem>
                    <GridTabItem id='commercial-tab'
                                 text={t("serviceWork.grid.commercial-tab")}
                                 queryKey='1'>
                    </GridTabItem>
                </GridTabSection>
                <GridTabSection type={GridTabSectionType.Button}>
                    <GridTabItem id='refresh-btn'
                                 text={t("btn.refresh")}
                                 icon={<FontAwesomeIcon icon={faRefresh}/> }>
                    </GridTabItem>
                </GridTabSection>
            </GridTab>
            {!query
                ? <Loader/>
                : <GridComponent id='grid'
                                 container='.list-container'
                                 url='/api/servicework/getserviceworks'
                                 query={query}
                                 filterStoreEntityName={'serviceWork'}
                                 onRowClick={onRowDoubleClick}
                                 refresh={refreshTrigger}
                                 filter={filterTrigger}
                                 sortSettings={{columns: [{field: 'name', direction: 'Ascending'}]}}>
                    <ColumnsDirective>
                        <ColumnDirective field='id'
                                         visible={false}
                                         textAlign="center"
                                         isPrimaryKey={true}
                                         type='number'/>
                        <ColumnDirective field='name'
                                         headerText={t("serviceWork.grid.name")}
                                         width='320'
                                         textAlign='center'/>
                        <ColumnDirective field='cost'
                                         headerText={t("serviceWork.grid.cost")}
                                         width='140'
                                         textAlign='center'/>
                        <ColumnDirective field='unitName'
                                         headerText={t("serviceWork.grid.unit")}
                                         width='140'
                                         textAlign='center'/>
                        <ColumnDirective field='service360Id'
                                         headerText={t("serviceWork.grid.serviceId")}
                                         width='220'
                                         textAlign='center'
                                         valueAccessor={(field, data) => data.service360Name}
                                         filterTemplate={(props) => <ServiceWorkCategoryFilter
                                             onFilterChange={(ev, fieldName) => setFilterTrigger({
                                                 ev,
                                                 fieldName
                                             })} filterStoreEntityName={'serviceWork'} {...props}/>}/>
                        <ColumnDirective field='targetLabel'
                                         headerText={t("serviceWork.grid.target")}
                                         width='280'
                                         textAlign='center'
                                         allowSorting={false}
                                         allowFiltering={false}/>
                    </ColumnsDirective>
                    <Inject services={[Pager, Sort, Filter]}/>
                </GridComponent>
            }
        </div>
    );
};

export default ServiceWork;

